var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkOrangePlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C8.28403 2 8.51429 2.23025 8.51429 2.51429V7.48571H13.4857C13.7697 7.48571 14 7.71597 14 8C14 8.28403 13.7697 8.51429 13.4857 8.51429H8.51429V13.4857C8.51429 13.7697 8.28403 14 8 14C7.71597 14 7.48571 13.7697 7.48571 13.4857V8.51429H2.51429C2.23025 8.51429 2 8.28403 2 8C2 7.71597 2.23025 7.48571 2.51429 7.48571H7.48571V2.51429C7.48571 2.23025 7.71597 2 8 2Z",
    fill: "#D53E20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkOrangePlus);
export default __webpack_public_path__ + "static/media/dark-orange-plus.7a44485fa0659a44b25249515ac01904.svg";
export { ForwardRef as ReactComponent };